<template>
  <div>
    <v-row
      justify="space-between"
      align="center"
      class="legendHead mx-auto my-0"
    >
      <h3>Discovery Tool</h3>
      <div @click="showDiscovery = !showDiscovery">
        <v-icon color="#58e2c2" size="25" v-if="!showDiscovery" :data-test-id="`${dataTestId}__add-icon`">add</v-icon>
        <v-icon class="icon-top" color="#58e2c2" size="25" v-if="showDiscovery"
        :data-test-id="`${dataTestId}__maximize-icon`">maximize</v-icon
        >
      </div>
    </v-row>
    <v-row>
      <v-col v-if="showDiscovery">
        <v-divider dark></v-divider>
        <v-row class="mx-0 actionTables">
          <table cellspacing="0" class="vgt-table">
            <thead>
              <tr>
                <th class="text-left">Number of Minimum Approvers</th>
                <th class="text-left"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td width="50%">Litigation Project</td>
                <td width="50%" class="positionRelative" :data-test-id="`${dataTestId}__litigation-project-select-box-wrapper`">
                  <v-select
                    :items="counts"
                    solo
                    flat
                    v-model.number="litigationSelected"
                    item-value="key"
                    item-text="value"
                    append-icon="keyboard_arrow_down"
                    class="cursorPointerx"
                    background-color="#E5E5E5 !important"
                    v-if="!initialLoading"
                    height="50px"
                    :attach="`[data-test-id='${dataTestId}__litigation-project-select-box-wrapper']`"
                  ></v-select>
                  <v-skeleton-loader
                    v-else
                    type="button"
                    :loading="true"
                    min-width="100%"
                  ></v-skeleton-loader>
                </td>
              </tr>
              <tr>
                <td width="50%">Data Subject Project</td>
                <td width="50%" class="positionRelative"
                  :data-test-id="`${dataTestId}__data-subject-project-select-box-wrapper`">
                  <v-select
                    :items="counts"
                    solo
                    flat
                    v-model.number="dataSubjectProjectSelected"
                    item-value="key"
                    item-text="value"
                    append-icon="keyboard_arrow_down"
                    class="cursorPointerx"
                    background-color="white !important"
                    v-if="!initialLoading"
                    height="50px"
                    :attach="`[data-test-id='${dataTestId}__data-subject-project-select-box-wrapper']`"
                  ></v-select>
                  <v-skeleton-loader
                    v-else
                    type="button"
                    :loading="true"
                    min-width="100%"
                  ></v-skeleton-loader>
                </td>
              </tr>
              <tr v-if="canViewApprovalDeletion">
                <td width="50%">Data Subject Deletion Request</td>
                <td width="50%" class="positionRelative" :data-test-id="`${dataTestId}__data-subject-deletion-project-select-box-wrapper`">
                  <v-select
                    :items="counts"
                    solo
                    flat
                    v-model.number="dataSubjectDeletionSelected"
                    item-value="key"
                    item-text="value"
                    append-icon="keyboard_arrow_down"
                    class="cursorPointerx"
                    background-color="#E5E5E5 !important"
                    v-if="!initialLoading"
                    height="50px"
                    :attach="`[data-test-id='${dataTestId}__data-subject-deletion-project-select-box-wrapper']`"
                  ></v-select>
                  <v-skeleton-loader
                    v-else
                    type="button"
                    :loading="true"
                    min-width="100%"
                  ></v-skeleton-loader>
                </td>
              </tr>
            </tbody>
          </table>
        </v-row>
        <v-row justify="end" v-if="!initialLoading">
          <v-col class="my-5 text-right">
            <x-button
              outline
              color="#58e2c2"
              buttonText="Reset"
              @click="getApproverCounts"
              :data-test-id="`${dataTestId}__reset-btn`"
            />
            <x-button
              color="#58e2c2"
              buttonText="Save Settings"
              @click="openConfirmBox"
              class="ml-2"
              :data-test-id="`${dataTestId}__save-settings-btn`"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <x-dialog
      :dialogState="confirmDialogueVar"
      :dialogTitle="dialogTitle"
      :dialogText="dialogText"
      :confirmDialog="true"
      @toggleModal="closeConfirmBox"
      :actions="{
        show: true,
        secondaryButtonFunction: closeConfirmBox,
        primaryButtonFunction: saveApproverSettings,
        primaryButtonShow: true,
        secondaryButtonText: cancelText,
        primaryButtonText: successText,
      }"
      :data-test-id="`${dataTestId}__save-settings-confirmation-dialog`"
    ></x-dialog>
  </div>
</template>

<script>
import PreferencesService from '@/services/PreferencesService';
import PreferenceHelper from '@/helpers/PreferenceHelper';
export default {
  computed: {
    canViewApprovalDeletion() {
      return this.$can('view', 'approval_deletion_request');
    }
  },
  created() {
    this.preferenceServiceHelper = new PreferenceHelper();
  },
  mounted() {
    this.getApproverCounts();
  },
  data() {
    return {
      showDiscovery: true,
      // this is needed for displaying approver count dropdown
      // eslint-disable-next-line
      counts: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      litigationSelected: 1,
      dataSubjectProjectSelected: 1,
      dataSubjectDeletionSelected: 1,
      approverKeyId: '',
      dialogTitle: 'Please Confirm',
      dialogText:
        'Are you sure you want to save Business Continuity settings ?',
      cancelText: '',
      successText: 'Yes',
      confirmDialogueVar: false,
      preferenceServiceHelper: null,
      initialLoading: false,
      dataTestId:'configuration__approval-settings'
    };
  },
  methods: {
    async getApproverCounts() {
      this.initialLoading = true;
      try {
        let response = await PreferencesService.getPreferencesByPreferenceKey(
          this.$preference.DISCOVERY_TOOL_MINIMUM_APPROVER
        );
        let parsedResponse = this.parseResponse(response);
        if (parsedResponse) {
          this.litigationSelected =
            parsedResponse[0].results[0].data.approvers.litigation_project;
          this.dataSubjectProjectSelected =
            parsedResponse[0].results[0].data.approvers.data_subject_project;
          this.dataSubjectDeletionSelected =
            parsedResponse[0].results[0].data.approvers.deletion_request;
          this.approverKeyId = parsedResponse[0].results[0].id;
        } else {
          this.snackbar('error', this.$message.CANNOT_LOAD_SETTING_DATA);
        }
        this.initialLoading = false;
      } catch (err) {
        this.snackbar('error', err);
        this.initialLoading = false;
      }
    },
    async saveApproverSettings() {
      let reqObject = this.preferenceServiceHelper.createPreferenceBody(
        'discoveryApproverSetting',
        {
          litigation: this.litigationSelected,
          subject: this.dataSubjectProjectSelected,
          deletion: this.dataSubjectDeletionSelected,
        },
        'approvers'
      );
      let url = '';
      if (
        this.approverKeyId === this.preferenceServiceHelper.defaultPreferenceId
      ) {
        url = PreferencesService.addPreference(
          this.$preference.DISCOVERY_TOOL_MINIMUM_APPROVER,
          reqObject
        );
      } else {
        url = PreferencesService.updatePreference(
          this.$preference.DISCOVERY_TOOL_MINIMUM_APPROVER,
          this.approverKeyId,
          reqObject
        );
      }
      try {
        let res = await url;
        let parsedResponse = this.parseResponse(res);
        if (parsedResponse !== false) {
          this.litigationSelected =
            parsedResponse[0].data.approvers.litigation_project;
          this.dataSubjectProjectSelected =
            parsedResponse[0].data.approvers.data_subject_project;
          this.dataSubjectDeletionSelected =
            parsedResponse[0].data.approvers.deletion_request;
          this.approverKeyId = parsedResponse[0].id;
          this.snackbar('success', this.$message.SAVED_SUCCESS);
        } else {
          this.snackbar('error', this.$message.CANNOT_LOAD_SETTING_DATA);
        }
        this.confirmDialogueVar = false;
      } catch (err) {
        this.snackbar('error', err);
      }
    },
    openConfirmBox() {
      this.dialogTitle = 'Please Confirm';
      this.dialogText =
        'Are you sure you want to save Number of Minimum Approver settings ?';
      this.cancelText = 'Cancel';
      this.successText = 'Yes';
      this.confirmDialogueVar = true;
    },
    closeConfirmBox() {
      this.confirmDialogueVar = false;
    },
  },
  watch: {
    currentlySelectedOrgId: function () {
      this.getApproverCounts();
    },
  },
};
</script>

<style>
.v-skeleton-loader__button {
  width: 100%;
  height: 50px;
}
</style>
